import { useState, useEffect } from 'react'

const AUTO_REFRESH_KEY = 'autoRefresh'
const REFRESH_INTERVAL = 10000 // 10 seconds

/**
 * Hook to read auto-refresh state from localStorage
 * This syncs with the header's auto-refresh toggle
 */
export function useAutoRefresh() {
  const [autoRefresh, setAutoRefresh] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem(AUTO_REFRESH_KEY) === 'true'
    }
    return false
  })

  // Listen for storage changes (when header toggle changes)
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === AUTO_REFRESH_KEY) {
        setAutoRefresh(e.newValue === 'true')
      }
    }

    // Also poll localStorage since storage events don't fire in the same tab
    const interval = setInterval(() => {
      const current = localStorage.getItem(AUTO_REFRESH_KEY) === 'true'
      setAutoRefresh(prev => {
        if (prev !== current) return current
        return prev
      })
    }, 500)

    window.addEventListener('storage', handleStorageChange)
    return () => {
      window.removeEventListener('storage', handleStorageChange)
      clearInterval(interval)
    }
  }, [])

  return {
    autoRefresh,
    refetchInterval: autoRefresh ? REFRESH_INTERVAL : false as const,
  }
}
